var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MembersList/MembersListAvailability.jinja"] = require( "front/components/MembersList/MembersListAvailability.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MembersList/MembersListInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MembersList/MembersListInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MembersList/MembersListAvailability.jinja", false, "assets/app/front/components/MembersList/MembersListInner.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MembersListAvailability")) {
var t_7 = t_4.MembersListAvailability;
} else {
cb(new Error("cannot import 'MembersListAvailability'")); return;
}
context.setVariable("MembersListAvailability", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data", "limit", "tp", "page"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("limit", Object.prototype.hasOwnProperty.call(kwargs, "limit") ? kwargs["limit"] : 20);frame.set("tp", Object.prototype.hasOwnProperty.call(kwargs, "tp") ? kwargs["tp"] : "featured");frame.set("page", Object.prototype.hasOwnProperty.call(kwargs, "page") ? kwargs["page"] : 0);var t_9 = "";t_9 += "\n    ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "data"))) {
t_9 += "\n        ";
frame = frame.push();
var t_12 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("member", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n            <div class=\"MembersListInner-member";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") > runtime.contextOrFrameLookup(context, frame, "limit")) {
t_9 += " MembersListInner-member--hidden";
;
}
t_9 += "\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_9 += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") % 5) * 50, env.opts.autoescape);
t_9 += "\">\n\n                ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 5 && runtime.contextOrFrameLookup(context, frame, "tp") == "featured" && runtime.contextOrFrameLookup(context, frame, "page") == 0)) {
t_9 += "\n                    <div class=\"MembersListInner-featuredBanner\">\n                        ";
t_9 += runtime.suppressValue((lineno = 11, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MembersListAvailability"), "MembersListAvailability", context, [])), env.opts.autoescape);
t_9 += "\n                    </div>\n                ";
;
}
t_9 += "\n\n                <a class=\"MembersListInner-memberLink\" href=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"url"), env.opts.autoescape);
t_9 += "\">\n                    <figure>\n                        <div class=\"MembersListInner-memberImageWrapper\">\n                            <div class=\"MembersListInner-memberImage\">\n                                ";
if(runtime.memberLookup((t_13),"img")) {
t_9 += "\n                                    ";
if(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w200_url")) {
t_9 += "<img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w400_url"), env.opts.autoescape);
t_9 += "\"\n                                          srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w400_url"), env.opts.autoescape);
t_9 += " 2x\"\n                                          alt=\"\">\n                                    ";
;
}
else {
t_9 += "<img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w680_url"), env.opts.autoescape);
t_9 += "\"\n                                          srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w920_url"), env.opts.autoescape);
t_9 += " 2x\"\n                                          alt=\"\">\n                                    ";
;
}
;
}
else {
t_9 += "\n                                    <img src=\"";
t_9 += runtime.suppressValue((lineno = 30, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/default-member-" + env.getFilter("string").call(context, (runtime.memberLookup((t_13),"defaultImg") % 5)) + ".png"])), env.opts.autoescape);
t_9 += "\" alt=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"name"), env.opts.autoescape);
t_9 += "\">\n                                    <div class=\"MembersListInner-memberImageInitials\">\n                                        ";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"initials"), env.opts.autoescape);
t_9 += "\n                                    </div>\n                                ";
;
}
t_9 += "\n                            </div>\n                            <div class=\"MembersListInner-caption\">\n                                <div class=\"MembersListInner-captionInner\">\n                                    <h3>";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"name"), env.opts.autoescape);
t_9 += "</h3>\n                                    <div class=\"MembersListInner-captionJob\">\n                                        <p>";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"classification"), env.opts.autoescape);
t_9 += "</p>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </figure>\n                </a>\n            </div>\n        ";
;
}
}
frame = frame.pop();
t_9 += "\n    ";
;
}
else {
t_9 += "\n        <div class=\"MembersListInner-empty\">\n            Unfortunately none of the members<br> in our database match your criteria.<br> Try <span>clearing filters</span>, or search for something else.\n        </div>\n    ";
;
}
t_9 += "\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MembersListInner");
context.setVariable("MembersListInner", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MembersList/MembersListInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MembersList/MembersListInner.jinja
// module id = 56
// module chunks = 0